import React from 'react';
import { useField } from 'react-final-form';
import * as Styled from '../AudioScriptPlaybackCard.styled';

const LoadingPlaybackCard = () => {
  // Get AI voice value from form to determine colors
  const {
    input: { value: aiVoice },
  } = useField('aiVoice');

  return (
    <Styled.Container variant="highlight" selectedVoice={aiVoice}>
      <Styled.Content>
        <Styled.LoadingIndicator size="large" selectedVoice={aiVoice} />
        <Styled.TextContainer>
          <Styled.Text>
            Hang tight while we give things a good mix...
          </Styled.Text>
          <Styled.Caption>This could take up to 30 seconds.</Styled.Caption>
        </Styled.TextContainer>
      </Styled.Content>
    </Styled.Container>
  );
};

export default LoadingPlaybackCard;
